<template lang="pug">
  .layout
    y-dialog(v-if="showModal" v-model='showModal', scrollable='', max-width='600px' persistent)
      v-card
        v-card-title
          v-layout
            div.title Images
            v-btn.my-auto.ml-2(color='accent' small outlined height=20 @click="showAddProductDialog =! showAddProductDialog")
              v-icon.ml-n2(left size=14) mdi-plus
              div.ml-n2.mr-n1  Add

        v-divider
        v-card-text
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            v-layout.my-6(v-if="images.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption No extra images yet
            .items-layout.pt-4(v-else)
              .list-item.my-2(three-line)
                template(v-for='image in images')
                  tenant-image-item(:settings="settings" :image="image" :key="image.id" @deleted="handleDeleteItem")
          div.mt-4
            v-pagination(v-if="totalPage >= 2" v-model='page' :length='totalPage' :total-visible="6")
          
        v-divider
        v-card-actions
          v-spacer
          v-btn.mr-2(color='grey', text='', @click='showModal = false') Close
    
    .modals
      add-new-tenant-image(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :settings="settings" :tenant="tenant" @added="handleAddItem")

</template>

<script>
import { mapGetters } from 'vuex'
import TenantImageItem from '@/components/TenantImageItem.vue'
import AddNewTenantImage from '@/components/dialogs/AddNewTenantImage.vue'
export default {
  name: 'ManageTenantImagesDialog',
  props: ['open', 'settings'],
  components: { TenantImageItem, AddNewTenantImage },
  data: () => ({
    isFetching: false,
    fetchCount: 10,
    page: 1,
    totalPage: 1,
    images: [],
    showAddProductDialog: false
  }),
  mounted () {
    this.fetchProducts(1)
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/images`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.images = response.data.results
        const totalCount = response.data.count
        if (totalCount % this.fetchCount == 0) {
          this.totalPage = totalCount/this.fetchCount
        } else {
          this.totalPage = totalCount/this.fetchCount + 1
        }
        this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    handleDeleteItem (item) {
      this.images = this.images.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.images.push(item)
      this.$emit('activated')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "option": {
      "placeholder": "Tulis Nama option di sini"
    },
    "add": "Perbarui",
    "add": "Create"
  }
}
</i18n>
